import { GridWrapper } from "../bits/layout/Grid";
import { useTitle } from "../hooks/useTitle";
import { ManagementViewHeader } from "../patterns/ManagementViewHeader";
import { css, useTheme } from "@emotion/react";
import { Link } from "react-router";

export const ErrorPage = ({
  message,
  subheader = "Something went wrong",
}: {
  message: string;
  subheader?: string;
}) => {
  const theme = useTheme();
  useTitle("Error | Compass");

  return (
    <GridWrapper>
      <ManagementViewHeader sidePanelOpen={false} />
      <div
        css={css`
          height: 100%;
          width: 100vw;
          width: 100dvw;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          gap: 48px;
        `}
      >
        <div
          css={css`
            display: flex;
            flex-direction: column;
            align-items: center;
          `}
        >
          <h1
            style={{
              ...theme.customTypography.jumbo._1,
              color: theme.colours.primary.dark._20,
            }}
          >
            Error
          </h1>
          <h2
            style={{
              ...theme.customTypography.jumbo._3,
              color: theme.colours.primary.dark._20,
            }}
          >
            {subheader}
          </h2>
        </div>
        <div
          css={css`
            display: flex;
            flex-direction: column;
            align-items: center;
            ${theme.customTypography.title._3}
            ${theme.colours.primary.dark._20}
          `}
        >
          {message}
        </div>
        <div
          css={css`
            display: flex;
            flex-direction: column;
            align-items: center;
            ${theme.customTypography.jumbo._5}
            ${theme.colours.primary.dark._20}
          `}
        >
          <p>
            <Link to="/">Click here</Link> to return to the homepage.
          </p>
          <p>
            If this error persists, please contact support at{" "}
            <a href="mailto:info@classlegal.com">info@classlegal.com</a>
          </p>
        </div>
      </div>
    </GridWrapper>
  );
};
